export default __webpack_public_path__ + "static/media/mid-gard-video-bg.13973d41.png";